
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import BudgetGroupsListView from "./budget_groups-list.html";
import BudgetGroupsEditView from "./budget_groups-edit.html";

angular.module("budget_groups", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('budget_groups', {
                url: "/budget_groups",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('budget_groups.list', {
                url: "/list",
                controller: "BudgetGroupsListCtrl",
                template: BudgetGroupsListView,
                requiredPermission: ["BUDGET_GROUPS_READ"]
            })            
            .state('budget_groups.edit', {
                url: "/edit/:id",
                controller: "BudgetGroupsEditCtrl",
                template: BudgetGroupsEditView,
                requiredPermission: ["BUDGET_GROUPS_READ"]
            })
    }])
;